import { useEffect, useRef } from "react";

export function usePrevValue<Value>(value?: Value): Value | null {
  const ref = useRef(null);

  useEffect(() => {
    ref.current = value;
  }, [value]);

  return ref.current;
}
